var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCylindertracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.883 4.4232C10.883 4.05575 11.176 3.75781 11.5375 3.75781C11.8989 3.75781 12.192 4.05575 12.192 4.4232V7.39539C12.192 7.46884 12.1334 7.52854 12.061 7.52854H11.0138C10.9415 7.52854 10.8828 7.46902 10.8828 7.39539V4.4232H10.883Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5385 3.75914V3.09375V3.75914ZM11.5385 3.09375H11.3203H11.5385ZM11.5385 3.09375H11.7566H11.5385Z",
    fill: "#919EAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5385 3.75914V3.09375M11.5385 3.09375H11.3203M11.5385 3.09375H11.7566",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.5127L1 17.8928V2.20663L3.33333 3.41326M8 21.5127L15 17.8928M8 21.5127V14.273M15 17.8928L22 21.5127V5.82653L19.6667 4.6199M15 17.8928V14.273M15 4.86122C15 6.99371 13.25 8.72244 11.5 10.6531C9.75 8.72244 8 6.99371 8 4.86122C8 2.72873 9.56695 1 11.5 1C13.4331 1 15 2.72873 15 4.86122Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylindertracking);
export default __webpack_public_path__ + "static/media/cylinder tracking.6146adea84b50fa78f4844562aab34b3.svg";
export { ForwardRef as ReactComponent };